import { Controller } from "stimulus";
export default class extends Controller {
  static targets = [
    "quickshop",
    "content",
    "loader",
    "options",
    "variantSelector",
    "price",
    "button",
    "buttonState",
    "link",
  ];

  initialize() {
    this.quickshopTarget.addEventListener("click", (e) => {
      if (e.target.classList.contains("quickshop-wrap")) {
        this.toggleQuickshop(e);
      }
    });
  }

  toggleQuickshop(e) {
    e.stopPropagation();
    e.preventDefault();
    this.uiController.toggleOverflow();

    this.quickshopTarget.classList.toggle("quickshop-wrap--active");

    if (this.quickshopTarget.classList.contains("quickshop-wrap--active")) {
      const { product: handle, id, available } = e.currentTarget.dataset;
      this.buildQuickshop(handle, id, available);
    } else {
      this.resetQuickshop();
    }
  }

  resetQuickshop() {
    this.contentTarget.innerHTML = "";

    setTimeout(() => {
      this.loaderTarget.classList.toggle("hidden");
    }, 300);
  }

  handleChange(e) {
    const selectedOptions =
      this.optionsTarget.querySelectorAll("option:checked");

    const selectedOptionValues = Array.from(selectedOptions)
      .map((option) => {
        return option.value;
      })
      .join(":");

    this.variantSelectorTarget.querySelectorAll("option").forEach((option) => {
      if (option.dataset.options == selectedOptionValues) {
        option.selected = true;
      } else {
        option.selected = false;
      }
    });

    const newVariant =
      this.variantSelectorTarget.querySelector("option:checked");

    this.handlePrice(newVariant);
    this.handleButtonState(newVariant);
    this.handleLink(newVariant);
    this.handleUnavailableVariants(e.currentTarget);
  }

  handleUnavailableVariants(changedOption) {
    const options = this.variantSelectorTarget.querySelectorAll("option");
    let filteredOptions = Array.from(options).filter((option) =>
      option.dataset.options.includes(changedOption.value)
    );

    const remainingFields = Array.from(
      this.optionsTarget.querySelectorAll("select")
    ).filter((target) => target !== changedOption);

    if (filteredOptions.length > 0) {
      filteredOptions = filteredOptions.map((option) => option.dataset.options);
      remainingFields.forEach((target) => {
        const targetOptions = target.querySelectorAll("option");

        targetOptions.forEach((option) => {
          const optionExists = filteredOptions.some((o) => {
            return o.includes(option.value);
          });

          if (optionExists) {
            option.disabled = false;
          } else {
            option.disabled = true;
          }
        });
      });
    }
  }

  handlePrice(option) {
    this.priceTarget.innerText = `${document.body.dataset.currency}${option.dataset.price}`;
  }

  handleButtonState(option) {
    if (option?.dataset.policy === "continue") {
      this.buttonStateTarget.innerText = "Add to cart";
      this.buttonTarget.disabled = false;
    } else if (!option || parseInt(option?.dataset.inventory) < 0) {
      this.buttonStateTarget.innerText = "Sold Out";
      this.buttonTarget.disabled = true;
    }
  }

  handleLink(option) {
    if (this.linkTarget.href.includes("?variant")) {
      const firstPartUrl = this.linkTarget.href.split("?")[0];
      this.linkTarget.href = `${firstPartUrl}?variant=${option.value}`;
    } else {
      this.linkTarget.href += `?variant=${option.value}`;
    }
  }

  async buildQuickshop(handle, id, available) {
    try {
      const res = await fetch(`/products/${handle}.json`);
      const metaRes = await fetch(`/pages/products_json`);

      if (res.ok && metaRes.ok) {
        const { product } = await res.json();
        const productsMeta = await metaRes.json();
        const productMeta = productsMeta.find(
          (product) => product.product_id == id
        );

        const productCollections = productMeta?.collections;

        this.loaderTarget.classList.toggle("hidden");
        this.contentTarget.innerHTML = `
          <!-- Left Block -->
          <div class="quickshop__block">
            <h2 class="quickshop__title">${product.title}</h2>
            ${
              productMeta.flavour_notes
                ? `
                <p class="quickshop__flavour-notes">
                  ${productMeta.flavour_notes.join(", ")}
                </p>
            `
                : ""
            }
    
            <div class="quickshop__featured-image">
              <img
                class="quickshop__featured-image"
                src="${productMeta?.floating_image || product.image.src}"
                alt="${product.title}"
                height="400"
                width="400"
                loading="lazy"
              />
            </div>
          </div>
    
          <!-- Right Block -->
          <div class="quickshop__block">
            <select class="hidden" data-quickshop-target="variantSelector">
              ${product.variants
                .map((variant) => {
                  const currentVariant = productMeta.variants.find(
                    (v) => v.id == variant.id
                  );

                  return `
                  <option
                    value="${variant.id}"
                    data-price='${variant.price}'
                    data-inventory="${currentVariant?.quantity}"
                    data-policy="${currentVariant?.policy}"
                    data-options="${variant.title
                      .toLowerCase()
                      .split(" / ")
                      .join(":")
                      .split(" ")
                      .join("-")}"
                  >
                    ${variant.title}
                  </option>
                `;
                })
                .join("")}
            </select>
            <div class="quickshop__options" data-quickshop-target="options">
              ${
                product.variants.length > 1
                  ? product.options
                      .map(
                        (option) => `
                  <div>
                    <label 
                      for="quickshop-option-${option.name
                        .split(" ")
                        .join("-")
                        .toLowerCase()}"
                    >
                      ${option.name}
                    </label>
                    <div class="quickshop__option">
                      <select data-action="quickshop#handleChange">
                        ${option.values
                          .map(
                            (value) => `
                              <option
                                value="${value
                                  .split(" ")
                                  .join("-")
                                  .toLowerCase()}"
                              >
                                ${value}
                              </option>
                            `
                          )
                          .join("")}
                      </select>
                    </div>
                  </div>
                `
                      )
                      .join("")
                  : ""
              }
            </div>
    
            <div class="quickshop__button-group">
            ${
              !productCollections.includes("commercial-equipment")
                ? `
              <button ${
                !(available === "false") ? "" : "disabled"
              } class="quickshop__button" type="submit" data-quickshop-target="button" data-action="quickshop#postToCart">
                ${
                  !(available === "false")
                    ? `
                    <span data-quickshop-target="buttonState">Add to bag</span>-&nbsp;
                    <span data-quickshop-target="price">
                      ${
                        document.body.dataset.currency +
                        parseFloat(product.variants[0].price).toFixed(2)
                      }
                    </span>
                  `
                    : "<span>Out of Stock</span>"
                }
              </button>
              `
                : ""
            }

              <a class="quickshop__button" href="/products/${
                product.handle
              }" data-quickshop-target="link">
                View
              </a>
            </div>

            <div class="quickshop__description">
              ${productMeta.description}
            </div>
            <button class="quickshop__close" data-action="quickshop#toggleQuickshop" aria-label="close"></button>
          </div>
        `;
      } else {
        console.error(
          `Cannot open quickshop, please ensure a handle has been provided. ${res}`
        );
      }
    } catch (error) {
      console.error(
        `Cannot open quickshop, please ensure a handle has been provided ${error}`
      );
    }
  }

  async postToCart(event) {
    event.preventDefault();

    // Get the id and quantity
    const id = this.variantSelectorTarget.value;
    const qty = 1;

    try {
      const res = await this.quickCartController.addToCart([
        {
          id,
          quantity: qty,
        },
      ]);

      if (res.ok) {
        await this.quickCartController.getCartData(event);
        this.uiController.toggleOverflow();
        this.quickshopTarget.classList.toggle("quickshop-wrap--active");

        this.resetQuickshop();
      } else {
        this.quickCartController.toggleCart();
        this.quickCartController.errorMessageTarget.classList.remove("hidden");
        console.error("Problem performing AJAX", res);
      }
    } catch (err) {
      console.error("Problem performing AJAX", err);
    }
  }

  get uiController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "ui";
    });
  }

  get quickCartController() {
    return this.application.controllers.find((controller) => {
      return controller.context.identifier === "quick-cart";
    });
  }
}
